import React, { useState } from "react";
import "./esqueciSenha.css";
import "../../styles/bg-responsive.css";
import "../../styles/auth-logo.css";
import sbfLogo from "../../assets/SBF-Logo-1.png";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import { FaEnvelope, FaSpinner, FaArrowLeft, FaPaperPlane } from "react-icons/fa";
import api from "../../services/axios";

const EsqueciSenha = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [showLoading, setShowLoading] = useState(false);
  const [emailEnviado, setEmailEnviado] = useState(false);

  const notifyError = (mensagem) => toast.error(mensagem, { theme: "colored" });
  const notifySuccess = (mensagem) => toast.success(mensagem, { theme: "colored" });

  const validarEmail = (email) => {
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return regex.test(email);
  };

  const handleSolicitarReset = async () => {
    if (!email) {
      notifyError("Por favor, digite seu e-mail.");
      return;
    }

    if (!validarEmail(email)) {
      notifyError("Por favor, digite um e-mail válido.");
      return;
    }

    try {
      setShowLoading(true);

      const response = await api.post('/enviar-email-recuperacao', {
        email: email
      });

      if (response.data.success) {
        setEmailEnviado(true);
        notifySuccess("E-mail de redefinição enviado com sucesso!");
      } else {
        notifyError(response.data.mensagem || "Erro ao enviar e-mail de redefinição.");
      }
    } catch (error) {
      console.error("Erro ao solicitar reset:", error);
      if (error.response?.status === 404) {
        notifyError("E-mail não encontrado em nosso sistema.");
      } else {
        notifyError("Erro interno. Tente novamente.");
      }
    } finally {
      setShowLoading(false);
    }
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleSolicitarReset();
    }
  };

  if (emailEnviado) {
    return (
      <div id="container-esqueci-senha">
        <div id="container-central">
          <div className="logo-wrapper">
            <img src={sbfLogo} alt="SBF" id="img-logo" />
          </div>
          
          <div id="container-sucesso">
            <div className="success-icon">
              <FaPaperPlane size={60} color="#008c39" />
            </div>
            <h2>E-mail Enviado!</h2>
            <p>
              Enviamos um link de redefinição de senha para:
            </p>
            <div className="email-enviado">
              {email}
            </div>
            <p>
              Verifique sua caixa de entrada e spam. O link expira em 48 hora.
            </p>
            
            <div className="acoes-sucesso">
              <button
                className="btn btn-secondary"
                onClick={() => setEmailEnviado(false)}
              >
                Enviar para outro e-mail
              </button>
              <button
                className="btn btn-primary"
                onClick={() => navigate('/login')}
              >
                Voltar ao Login
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div id="container-esqueci-senha">
      <div id="container-central">
        <div className="logo-wrapper">
          <img src={sbfLogo} alt="SBF" id="img-logo" />
        </div>
        
        <div id="header-esqueci-senha">
          <div className="email-icon">
            <FaEnvelope size={40} color="#008c39" />
          </div>
          <h2>Esqueceu sua senha?</h2>
          <p>
            Digite seu e-mail e enviaremos um link para redefinir sua senha
          </p>
        </div>

        <div id="container-inputs">
          <div className="email-input-wrapper">
            <input
              type="email"
              placeholder="Digite seu e-mail"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              onKeyPress={handleKeyPress}
              disabled={showLoading}
              className="email-input"
              autoFocus
            />
          </div>

          <button
            className={`btn px-5 text-white mt-3 ${showLoading ? "bt-loading" : ""}`}
            id="botao-enviar"
            onClick={handleSolicitarReset}
            disabled={showLoading}
          >
            {showLoading ? (
              <>
                <FaSpinner className="fa-spin me-2" />
                Enviando...
              </>
            ) : (
              <>
                <FaPaperPlane className="me-2" />
                Enviar Link de Redefinição
              </>
            )}
          </button>

          <button
            className="btn btn-link mt-2"
            id="botao-voltar"
            onClick={() => navigate('/login')}
            disabled={showLoading}
          >
            <FaArrowLeft className="me-2" />
            Voltar ao Login
          </button>
        </div>

        <div id="info-adicional">
          <div className="info-card">
            <h6>Não recebeu o e-mail?</h6>
            <ul>
              <li>Verifique sua caixa de spam</li>
              <li>Aguarde alguns minutos</li>
              <li>Certifique-se de que o e-mail está correto</li>
              <li>Entre em contato conosco se persistir</li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EsqueciSenha; 